import { Drawer, DrawerContent, DrawerOverlay, useDisclosure } from '@chakra-ui/react'
import React from 'react'
import SideNav from './SideNav';

export default function MobileDrawer(props) {

    const { sidebar } = props;
    console.log(sidebar)

    return (
        <Drawer
            isOpen={sidebar.isOpen}
            onClose={sidebar.onClose}
            placement="left"

        >
            <DrawerOverlay background="transparent" />
            <DrawerContent
                background="transparent"
                boxShadow="none"
                onClick={sidebar.onClose}
            >
                <SideNav
                // w="60"
                // borderRight="none" 
                />
            </DrawerContent>
        </Drawer>
    )
}
